<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-md-2">
            <div class="col-sm-12 col-lg-6 mb-1">
              <div class="dataTables_length" id="tickets-table_length">
                <label class="d-inline-flex align-items-center">
                  Afișează
                  <select
                    name="tickets-table_length"
                    aria-controls="tickets-table"
                    name="pageSize"
                    [(ngModel)]="notaControlCppcService.pageSize"
                    [disabled]="loadingDataSpinner"
                    (change)="changePageSize($event.target.value)"
                    class="custom-select custom-select-sm form-control form-control-sm mx-2"
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  intrări
                </label>
              </div>
            </div>

            <div class="col-sm-12 col-lg-6">
              <div id="tickets-table_filter" class="d-flex justify-content-end">
                <button
                  *ngIf="isAdmin || isOperator"
                  class="btn btn-blue btn-sm"
                  type="button"
                  (click)="adaugaNotaControlCPPC()"
                  [disabled]="loadingDataSpinner"
                >
                  <span class="mdi mdi-plus-circle"></span>
                  Adaugă Notă control CPPC
                </button>
              </div>
            </div>
          </div>

          <div
            *ngIf="loadingDataSpinner"
            class="spinner-border text-info table-spinner avatar-lg"
            role="status"
          ></div>

          <div class="table-responsive">
            <table class="table datatables dt-responsive nowrap table-hover">
              <thead>
                <tr>
                  <th>Notă control CPPC</th>
                  <th>Acțiuni</th>
                </tr>
              </thead>

              <tbody [ngClass]="{ disabled: loadingDataSpinner }">
                <tr *ngFor="let item of itemsList">
                  <td>{{ item['numar'] }} / {{ item['data_dmy'] }}</td>
                  <td class="action-buttons">
                    <div class="btn-group">
                      <button
                        *ngIf="isAdmin || isOperator"
                        class="btn btn-sm btn-success"
                        (click)="download($event, item)"
                      >
                        Descarcă
                      </button>

                      <button
                        *ngIf="isAdmin || isOperator"
                        class="btn btn-sm btn-warning"
                        (click)="openAnimaleModal(item['id'])"
                      >
                        Animale
                      </button>

                      <button
                        *ngIf="isSuperAdmin || (!item['readonly'] && (isAdmin || isOperator))"
                        class="btn btn-sm btn-blue"
                        (click)="openEditModal(item['id'])"
                      >
                        Editează
                      </button>

                      <button
                        *ngIf="isSuperAdmin || (!item['readonly'] && (isAdmin || isOperator))"
                        class="btn btn-sm btn-danger"
                        [ngClass]="'sterge-id-' + item['id']"
                        (click)="openDeleteModal(item['id'])"
                      >
                        Șterge
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <ngb-alert
              type="danger"
              class="text-center search-error"
              *ngIf="
                !loadingDataSpinner && notaControlCppcService.totalRecords === 0
              "
              [dismissible]="false"
            >
              Nu există înregistrări
            </ngb-alert>
          </div>

          <div
            class="row justify-content-lg-between align-items-lg-center mt-2"
            *ngIf="notaControlCppcService.totalRecords > 0"
          >
            <div class="col-sm-12 col-lg-6">
              <div
                class="dataTables_info mb-2"
                id="tickets-table_info"
                role="status"
                aria-live="polite"
              >
                Afișează de la
                {{ notaControlCppcService.startIndex }} la
                {{ notaControlCppcService.endIndex }} din
                {{ notaControlCppcService.totalRecords }}
                intrări
              </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-lg-6">
              <div class="text-lg-right float-lg-right pagination-rounded">
                <ngb-pagination
                  [disabled]="loadingDataSpinner"
                  [collectionSize]="notaControlCppcService.totalRecords"
                  [(page)]="notaControlCppcService.page"
                  [pageSize]="notaControlCppcService.pageSize"
                  [maxSize]="5"
                  (pageChange)="changePageNumber($event)"
                >
                </ngb-pagination>
              </div>
            </div>
            <!-- End Pagination -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-add-edit-nota-control-cppc
  [modalData]="addEditModalData"
  (notifyClose)="closeModal()"
></app-add-edit-nota-control-cppc>

<app-animale-nota-control-cppc
  [modalData]="animaleModalData"
></app-animale-nota-control-cppc>

<app-confirm-action-modal
  [open]="openDelete"
  [text]="'Șterge Nota control CPPC?'"
  (confirm)="closeDeleteModal($event)"
></app-confirm-action-modal>
